import { v4 as uuid } from 'uuid';
import {
    actionTypes as bookmakersInfoActionTypes,
} from './bookmakersInfo.actions';
import updateBet from './bookmakersInfo.bets.reducer';
import updateMultiple from './bookmakersInfo.multiples.reducer';
import {
    actions as freeBetsActions,
} from '../freeBets';
import updateBookmaker from './updateBookmaker.reducer';
import PRICE_TYPES from '../utils/priceTypes'
import { isLocalStorageAvailable, setLocalStorage } from '../utils/localStorage'


export const initialState = {
    betslipID: null,
    bookmakersOrder: null,
    selectedBookmaker: null,
    selectedBets: [],
    multiples: [],
    multiplesStakes: [],
    multiplesEachWay: [],
    isBuildingBet: false,
    isBuildingMultiples: false,
    genericError: {
        errorId: null,
        message: null,
    },
    unusedBets: [],
    previouslySelectedBookie: null,
};

const associateSingles = (selectedBets, singles) => selectedBets.map((selectedBet) => {
    const associatedBet = singles.find(selection =>
        selection.outcomersId === selectedBet.outcomersId,
    )
    return {
        ...selectedBet,
        associatedBet: {
            optionId: associatedBet.optionId,
            minStake: associatedBet.minStake,
            maxStake: associatedBet.maxStake,
            numberLines: associatedBet.numberLines,
        },
    }
})

export default (state = initialState, action) => {
    let betAlreadyAdded
    let selectedBets
    let betslipID

    switch (action.type) {
        case bookmakersInfoActionTypes.SET_BOOKMAKERS_ORDER:
            return {
                ...state,
                bookmakersOrder: action.bookmakersOrder,
                orderExpiration: action.orderExpiration,
            }

        // eslint-disable-next-line no-case-declarations
        case bookmakersInfoActionTypes.SET_SELECTED_BOOKMAKER:
            const previouslySelectedBookie = state.selectedBookmaker;

            if (isLocalStorageAvailable() && action.feed) {
                const selectedBookmakerFeed = action.feed === "PPWR" ? "PADDYPOWER" : action.feed
                setLocalStorage('selectedBookmaker', selectedBookmakerFeed);
             }
             

            return {
                ...state,
                previouslySelectedBookie,
                selectedBookmaker: action.feed,
            }

        case bookmakersInfoActionTypes.ADD_SELECTED_BET:

            betAlreadyAdded = state.selectedBets.filter(
                bet => bet.outcomersId === action.betInfo.outcomersId,
            ).length > 0

            // Maximum 10 bets
            if (betAlreadyAdded || state.selectedBets.length === 10) {
                return state
            }

            if (state.selectedBets.length === 0) {
                betslipID = `${uuid()}`;
            }

            return {
                ...state,
                selectedBets: [
                    ...state.selectedBets,
                    updateBet(undefined, action),
                ],
                betslipID: state.selectedBets.length !== 0 ? state.betslipID : betslipID,
            }

        case bookmakersInfoActionTypes.DELETE_BET:
            // Retain all bets other than the target we are deleting
            selectedBets = state.selectedBets.filter(
                bet => bet.outcomersId !== action.outcomersId,
            )

            return {
                ...state,
                selectedBets,
                betslipID: selectedBets.length === 0 ? null : state.betslipID,
            }

        case bookmakersInfoActionTypes.CLEAR_SELECTED_BETS:
            return {
                ...state,
                selectedBets: [],
                betslipID: null,
            };

        case bookmakersInfoActionTypes.CLEAR_SUSPENDED_BETS:
            selectedBets = state.selectedBets.filter(
                bet => bet.isSuspended === false,
            )

            return {
                ...state,
                selectedBets,
                betslipID: selectedBets.length === 0 ? null : state.betslipID,
            }

            // Selected Bets
        case bookmakersInfoActionTypes.SET_STAKE_FOR_SELECTED_BET:
        case bookmakersInfoActionTypes.SET_ISEACHWAY_FOR_SELECTED_BET:
        case bookmakersInfoActionTypes.SET_PRICE_TYPE_FOR_SELECTED_BET:
        case bookmakersInfoActionTypes.SET_ERROR:
        case bookmakersInfoActionTypes.SET_ERROR_ON_BUILD:
        case bookmakersInfoActionTypes.CLEAR_ERROR:
        case bookmakersInfoActionTypes.CLEAR_ALL_ERRORS:
        case bookmakersInfoActionTypes.SET_SUSPENDED_BET:
        case bookmakersInfoActionTypes.SET_SUSPENDED_BET_ON_BUILD:
        case bookmakersInfoActionTypes.SET_PRICE_CHANGED:
        case bookmakersInfoActionTypes.SET_PRICE_CHANGED_ON_BUILD:
        case bookmakersInfoActionTypes.UPDATE_ALL_BET_PRICES:
        case bookmakersInfoActionTypes.UPDATE_BET_PRICE:
        case bookmakersInfoActionTypes.UPDATE_ALL_STARTING_PRICES_AVAILABILITY:
        case bookmakersInfoActionTypes.TOGGLE_MULTIPLES_INCLUSION:
        case bookmakersInfoActionTypes.SET_MINIMUM_STAKE:
        case bookmakersInfoActionTypes.SET_MAXIMUM_STAKE:
        case bookmakersInfoActionTypes.SET_FREE_BET_MINIMUM_STAKE:
        case bookmakersInfoActionTypes.SET_FREE_BET_MAXIMUM_STAKE:
        case bookmakersInfoActionTypes.SET_LOCKED_STAKE:
        case bookmakersInfoActionTypes.CLEAR_LOCKED_STAKE:
        case freeBetsActions.actionTypes.FREE_BETS_CLEAR:
            {
                const updatedSingleBets = state.selectedBets.map(bet => updateBet(bet, action))

                return {
                    ...state,
                    selectedBets: updatedSingleBets,
                }
            }

        // Multiples
        case bookmakersInfoActionTypes.SET_MULTIPLES: {
            const updatedMultiples = action.multiples.map(
                multiple => updateMultiple(state, multiple, action),
            )

            return {
                ...state,
                multiples: updatedMultiples,
            }
        }

        case bookmakersInfoActionTypes.SAVE_MULTIPLES_STAKES: {
            const multiplesStakes = state.multiples.map(multiple => ({
                optionId: multiple.optionId,
                stake: multiple.stakeValue,
            }))

            return {
                ...state,
                multiplesStakes,
            }
        }

        case bookmakersInfoActionTypes.SAVE_MULTIPLES_EACHWAY: {
            const multiplesEachWay = state.multiples.map(multiple => ({
                optionId: multiple.optionId,
                isEachWay: multiple.isEachWay,
            }))

            return {
                ...state,
                multiplesEachWay,
            }
        }

        case bookmakersInfoActionTypes.SET_STAKE_FOR_MULTIPLE:
        case bookmakersInfoActionTypes.SET_IS_EACHWAY_FOR_MULTIPLE:
        case bookmakersInfoActionTypes.SET_IS_EDITING_STAKE_FOR_MULTIPLE:
        case bookmakersInfoActionTypes.SET_MULTIPLES_ERROR:
        case bookmakersInfoActionTypes.CLEAR_MULTIPLES_ERROR:
        case bookmakersInfoActionTypes.CLEAR_ALL_MULTIPLES_ERRORS:
        case bookmakersInfoActionTypes.CHANGE_SELECTION_ORDER:
        case bookmakersInfoActionTypes.RESTORE_MULTIPLES_STAKES:
        case bookmakersInfoActionTypes.RESTORE_MULTIPLES_EACHWAY: {
            const updatedMultiples = state.multiples.map(
                multiple => updateMultiple(state, multiple, action),
            )

            return {
                ...state,
                multiples: updatedMultiples,
            }
        }

        case bookmakersInfoActionTypes.BUILD_MULTIPLES_REQUEST:
            {
                return {
                    ...state,
                    isBuildingMultiples: action.isBuildingMultiples,
                }
            }

        case bookmakersInfoActionTypes.CLEAR_MULTIPLES:
            {
                return {
                    ...state,
                    multiples: [],
                }
            }

        case bookmakersInfoActionTypes.BUILD_BET_REQUEST:
            {
                return {
                    ...state,
                    isBuildingBet: action.isBuildingBet,
                }
            }

        case bookmakersInfoActionTypes.ASSOCIATE_SINGLES:
            {
                const associatedSingles = associateSingles(state.selectedBets, action.singles)

                return {
                    ...state,
                    selectedBets: associatedSingles,
                }
            }

        case bookmakersInfoActionTypes.TOGGLE_BALANCE_VISIBILITY:
        case bookmakersInfoActionTypes.REMOVE_USERNAME:
        case bookmakersInfoActionTypes.SAVE_USERNAME:
            {
                return {
                    ...state,
                    [action.feed]: updateBookmaker(state[action.feed], action),
                }
            }

        case bookmakersInfoActionTypes.SET_IS_EDITING_STAKE:
            return {
                ...state,
                selectedBets: state.selectedBets.map(
                    bet => updateBet(bet, action),
                ),
            };

        case bookmakersInfoActionTypes.SET_GENERIC_ERROR:
        case bookmakersInfoActionTypes.SET_GENERIC_ERROR_ON_BUILD:
            return {
                ...state,
                genericError: action.error,
            }

        case bookmakersInfoActionTypes.CLEAR_GENERIC_ERROR:
            return {
                ...state,
                genericError: {
                    errorId: null,
                    message: null,
                },
            }

        case bookmakersInfoActionTypes.SET_UNUSED_BETS:
            return {
                ...state,
                unusedBets: action.unusedBets.map(bet => ({
                    ...bet,
                    stake: '',
                    isEachWay: false,
                    priceType: (bet.isSpOnly) ?
                        PRICE_TYPES.SP : PRICE_TYPES.ODDS,
                })),
            }

        case bookmakersInfoActionTypes.CLEAR_UNUSED_BETS:
            return {
                ...state,
                unusedBets: [],
            }

        default:
            return state
    }
}



// WEBPACK FOOTER //
// /src/js/common/bookmakersInfo/bookmakersInfo.reducer.js